import { render } from "./ContentItem.vue?vue&type=template&id=8d6697e6&scoped=true"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"

import "./ContentItem.vue?vue&type=style&index=0&id=8d6697e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6697e6"]])

export default __exports__